import React from 'react'

const TripsTrips = () => (
  <article>
    <h2>Trips</h2>
    <p>
      Sue Flood is a highly-experienced wildlife and photography expedition
      guide, familiar with many different countries. Destinations visited
      regularly include Antarctica, Australia/ Tasmania, Botswana, British
      Columbia, the Falkland Islands and South Georgia, Japan, Madagascar, Papua
      New Guinea, Siberia, Svalbard and Zambia. Confirmed upcoming opportunities
      are listed below. But please feel welcome to get in touch to discuss other
      possibilities.
    </p>
    <p>
      <a
        href="https://www.steppestravel.com/wildlife-group-tours/sue-flood"
        target="_blank"
        rel="noreferrer"
      >
        Sue's Trips with Steppes Travel
      </a>
    </p>
    <p>
      In late May-June 2021 Sue will be guiding three luxury safaris to the
      award-winning{' '}
      <a href="https://bushcampcompany.com/" target="_blank" rel="noreferrer">
        Mfuwe Lodge
      </a>{' '}
      in South Luangwa National Park, Zambia with fellow pro-photographer Cindy
      Miller Hopkins. The first trip is sold out and trips two and three have
      started booking. If you’re interested, please email{' '}
      <a href="mailto:sue@sueflood.com">sue@sueflood.com</a> for details.
    </p>
    <p>
      In July 2021, Sue will be guiding an incredible trip with fellow
      pro-photographer Cindy Miller Hopkins to the{' '}
      <a
        href="https://docs.google.com/document/d/1SRhgNpslNCS8U_n8bXjEF3oysZkxBMOG4aD4RGTiRxg/edit"
        target="_blank"
        rel="noreferrer"
      >
        Nadaam festival in Mongolia, followed by a luxury Trans-Siberian train
        adventure onboard the famous Golden Eagle train
      </a>
      .
    </p>
  </article>
)

export default TripsTrips
